import isNumber from 'lodash/isNumber';
import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledDivComponent } from '../types';
import { Icon } from './Icon';
import { Image } from './Image';

/**
 * props:
 * - left -> for positioning left, default 'auto' (not in combination with right)
 * - right -> for positioning right, default 'auto' (not in combination with left)
 * - top -> for top position, default '0'
 * - noBg -> for transparent background
 * - flag -> to show the flag shadow (should be combined with top)
 * - watchlist -> Badge in watchlistitem
 */

interface BadgeProps {
  flag?: boolean;
  left?: number;
  right?: number;
  noBg?: boolean;
  watchlist?: boolean;
  isPremiumOffer?: boolean;
}

type BadgePropsThemed = BadgeProps & ThemeProps<Theme>;

export const Badge: StyledDivComponent<BadgeProps> = styled.div`
  position: absolute;
  top: ${(props: BadgePropsThemed) => (props.flag ?
  (props.isPremiumOffer ? '34px' : '-8px') :
  '0px')};
  left: ${(props: BadgePropsThemed) =>
    isNumber(props.left) ? props.left + 'px' : 'auto'};
  right: ${(props: BadgePropsThemed) =>
    isNumber(props.right) ? props.right + 'px' : 'auto'};
  background-color: ${(props: BadgePropsThemed) =>
    props.noBg ? 'transparent' : props.theme.colors.white};
  box-shadow: ${(props: BadgePropsThemed) =>
    props.flag ? props.theme.defaults.shadowDefault : 'none'};
  padding: ${(props: BadgePropsThemed) => props.theme.components.badge.padding};
  ${(props: BadgePropsThemed) =>
    font(
      props.theme.components.badge.fontSize,
      props.theme.components.badge.lineHeight,
      props.theme.components.badge.fontWeight
    )};
  text-transform: ${(props: BadgePropsThemed) =>
    props.theme.components.badge.textTransform};
  color: ${(props: BadgePropsThemed) => props.theme.colors.primary};
  z-index: 100;

  ${(props: BadgePropsThemed) =>
    props.flag &&
    css`
      :after {
        content: '';
        position: absolute;
        top: 0;
        right: -8px;
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 8px 0 0 8px;
        border-color: transparent transparent transparent
          ${props.theme.colors.gray};
      }
    `};

  ${(props: BadgePropsThemed) =>
    !props.flag &&
    props.watchlist &&
    css`
      right: 80px;

      ${media.large`
        right: 220px;
    `};
    `} span {
    vertical-align: middle;
  }

  ${Icon} {
    margin-right: 6px;
    height: 24px;

    svg {
      fill: ${(props: BadgePropsThemed) => props.theme.colors.primary};
    }
  }

  ${Image} {
    width: 80px;

    ${media.medium`
        width: 50px;
    `}

    ${media.large`
        width: 56px;
    `}
  }
`;
